import {isNil} from 'ramda';

import {RELEASE_BRANCH_PATTERN, RELEASE_TAG_PATTERN} from '@dms/config';

import {Nullish} from 'shared/web';

export type AppUpdateKind = 'patch' | 'release';

export function getAppUpdateKind(
  runningRef: string | Nullish,
  deployedRef: string | Nullish
): AppUpdateKind {
  const runningRelease =
    runningRef?.match(RELEASE_TAG_PATTERN) ?? runningRef?.match(RELEASE_BRANCH_PATTERN);
  const deployedRelease =
    deployedRef?.match(RELEASE_TAG_PATTERN) ?? deployedRef?.match(RELEASE_BRANCH_PATTERN);

  if (isNil(runningRelease) || isNil(deployedRelease)) {
    return 'release';
  }

  const [, runningMajor, runningMinor] = runningRelease;
  const [, deployedMajor, deployedMinor] = deployedRelease;

  return Number(runningMajor) === Number(deployedMajor) &&
    Number(runningMinor) === Number(deployedMinor)
    ? 'patch'
    : 'release';
}
